import { Typography } from 'seagull';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const MakeSteps = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Typography, {
    children: "2. Log in to your Make account and create a scenario with Anchor"
  }), /*#__PURE__*/_jsx(Typography, {
    children: "3. Paste the API key when setting up the connection"
  })]
});